/* eslint-disable */
import {isAutomationEnvironment, produktlyUtils, scriptUtils} from '@sendible/common';
import {EVENTS, subscribeOnce} from '@sendible/event-manager';

window.pendo = {
  initialize: () => {},
  identify: () => {},
  updateOptions: () => {},
  pageLoad: () => {},
  track: () => {},
  showGuideById: () => {},
}

if(!isAutomationEnvironment()) {
  const mainAppHosts = ['app.sendible.com', 'app.sendilab.com'];
  const isMainApp = mainAppHosts.includes(window.location.hostname);
  const isSubscriptionPage = window.location.pathname.startsWith('/subscription');
  const isEditorPage = window.location.pathname.startsWith('/editor');
  const isSignupPage = window.location.pathname.startsWith('/signup');
  const GTM_ID = GTM_CONTAINER_ID;

  // do not add tracking scripts to subscription, editor, or signup pages
  if (!isSubscriptionPage && !isEditorPage && !isSignupPage) {
    // only add script when feature tags have been loaded to ensure we know if user has produktly feature tag
    subscribeOnce(EVENTS.FEATURE_TAGS_LOADED, async () => {
      const user = window.sharedState?.user || {};
      const hasProduktly = produktlyUtils.hasProduktlyFeatureTag(user.featureTags);

      if (!hasProduktly) {
          // initialize pendo if user does not have produktly feature tag
          (function (apiKey) {
          (function (p, e, n, d, o) {
            let v; let w; let x; let y; let z; o = p[d] = p[d] || {}; o._q = [];
            v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w) {
              (function (m) {
                o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
              }(v[w]));
            }
            y = e.createElement(n); y.async = !0; y.src = `https://content.pendo.sendible.com/agent/static/${apiKey}/pendo.js`;
            z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
          }(window, document, 'script', 'pendo'));
        }(PENDO_API_KEY));
      } else {
        // initialize zendesk widget if user has produktly feature tag, 
        // but only if they are not a team member or client in a white label account
        const profile = window.$current_user?.profile;
        const isTeamMemberInWhiteLabel = !!user.isWhiteLabel && profile === 'Team Member';
        const isClient = profile === 'Client';

        if (!isTeamMemberInWhiteLabel && !isClient) {
          if (document.querySelector('script#ze-snippet')) {
            return;
          }
          await scriptUtils.addScriptToBody(`https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_WIDGET_KEY}`, { id: 'ze-snippet', async: true });
          zE('messenger', 'hide');
          zE('messenger:on', 'close', () => {
            zE('messenger', 'hide');
          });
        }
      
        // initialize produktly if user has produktly feature tag.
        // sendible360 queues identifyUser on the stub before FEATURE_TAGS_LOADED is published,
        // so the SDK replays it on load and never evaluates surveys for an anonymous visitor.
        (function (w, d, f) {
          if (d.getElementById('produktlyScript')) return;
          produktlyUtils.ensureProduktlyStub();
          var a = d.getElementsByTagName('head')[0];
          var s = d.createElement('script');
          s.async = 1;
          s.src = f;
          s.setAttribute('id', 'produktlyScript');
          s.dataset.clientToken = PRODUKTLY_CLIENT_TOKEN;
          a.appendChild(s);
        })(window, document, "https://public.produktly.com/js/main.js");
      }
    })
    if(isMainApp) {
      // initialize GTM if user is on main app
      if (!document.querySelector('script[src*="googletagmanager.com/gtm.js?id=' + GTM_ID + '"]')) {
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer',GTM_ID);
      }
      if (!document.querySelector('noscript[data-gtm]')) {
        var noscript = document.createElement('noscript');
        noscript.setAttribute('data-gtm', 'true');
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + GTM_ID;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
      }
    }
  }
}
export {};